/**
 * Portal access is granted only for emails the Admin added
 * (admins, support, consultants, or allowlist).
 */

export const UNAUTHORIZED_PORTAL_MESSAGE =
  'Authentication failed. Unrecognized user. Please contact your administrator.';

const normalizeEmail = (email) => (email || '').toLowerCase().trim();

const toSet = (list) =>
  new Set((list || []).map((e) => normalizeEmail(e)).filter(Boolean));

/**
 * Resolve portal role from Admin-managed Firestore lists.
 * Priority: admin > support > consultant. Allowlist-only maps to consultant.
 */
export const resolveUserRoleFromLists = (userEmail, lists = {}) => {
  const email = normalizeEmail(userEmail);
  if (!email) return null;

  const adminSet = toSet(lists.admins);
  const supportSet = toSet(lists.support);
  const consultantSet = toSet(lists.consultants);
  const allowlistSet = toSet(lists.allowlist);

  if (adminSet.has(email)) return 'admin';
  if (supportSet.has(email)) return 'support';
  if (consultantSet.has(email)) return 'consultant';
  if (allowlistSet.has(email)) return 'consultant';
  return null;
};

export const isAuthorizedPortalEmail = (userEmail, lists) =>
  Boolean(resolveUserRoleFromLists(userEmail, lists));
